
























































import { defineComponent } from '@nuxtjs/composition-api'
import { socialLogin } from '~/utils/helpers/login';

export default defineComponent({
    setup() { },
    mounted() {
        socialLogin(false, () => {
            setTimeout(()=>{
                Array.from(document.querySelectorAll('#socialLogin .icon')).forEach((el: HTMLElement) => {
                    Array.from(el.classList).forEach(cl => {
                        el.classList.add(cl.replace('icon', 'social-icons'));
                        el.classList.remove(cl)
                    })
    
                })
            },500)
        })
    }
})
